
import axios from 'axios';
import {ConfigService, RunConfigService } from '@nuskin/ns-util';

export
async function getAccountInfo (sapUserId, client) {
    try {
        const clientInfo = getClientInfo();

        const config = {
            responseType: 'json',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'client': client || 'aem',
                'client_id': clientInfo.clientId,
                'client_secret': clientInfo.clientSecret
            }
        };

        // eslint-disable-next-line max-len
        const source = `${RunConfigService.getBaseUrl()}/account-service/api/account/simple/${encodeURIComponent(sapUserId)}`;
        const res = await axios.get(source, config);
        return res.data;
    } catch (ex) {} // eslint-disable-line no-empty
}

function getClientInfo () {
    const marketConfig = ConfigService.getMarketConfig();

    return {
        clientId: marketConfig.checkout.clientId,
        clientSecret: marketConfig.checkout.clientSecret
    };
}
